import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { prequotedApis, quotesApis } from "../utils/apis";
import {
  createAxiosInstanceOrder,
  orderManagementApiRequest,
} from "../utils/request";

export const listAllPreQuotedCooks = createAsyncThunk(
  "listAllPreQuotedCooks",
  async (payload = {}) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const params = new URLSearchParams();
      if (payload?.brand_id) params.append("brand_id", payload.brand_id);
      if (payload?.set_id) params.append("set_id", payload.set_id);
      if (payload?.skip !== undefined && payload?.skip !== null) {
        params.append("skip", payload.skip);
      }
      if (payload?.limit !== undefined && payload?.limit !== null) {
        params.append("limit", payload.limit);
      }
      if (payload?.search) params.append("search", payload.search);
      if (payload?.sort_order) {
        params.append("sort_by", payload.sort_by);
        params.append("sort_order", payload.sort_order);
      }
      const query = params.toString();
      const response = await axiosInstance.get(
        query ? `${prequotedApis.getAllPreQuotes}?${query}` : prequotedApis.getAllPreQuotes
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const listAllPreQuoteBrands = createAsyncThunk(
  "listAllPreQuoteBrands",
  async () => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(prequotedApis.getAllPreQuoteBrands);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const listAllPreQuoteSets = createAsyncThunk(
  "listAllPreQuoteSets",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        `${prequotedApis.getAllPreQuoteSets}?brand_id=${payload?.brand_id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const listPreQuotedCooksById = createAsyncThunk(
  "listAllPreQuotedCooks",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        `${prequotedApis.getPreQuoteById}?${payload.prequote_id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const createPreQuotedCooks = createAsyncThunk(
  "createPreQuotedCooks",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.createPreQuotedCooks,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updatePreQuotedCooks = createAsyncThunk(
  "updatePreQuotedCooks",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.updatePreQuote,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updatePreQuotedCooksStatus = createAsyncThunk(
  "updatePreQuotedCooksStatus",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.updateStatusPreQuotes,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getApprovedQtyPQC = createAsyncThunk(
  "getApprovedQtyPQC",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        `${prequotedApis.getApprovedQty}?id=${payload?.id}`,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const createPQCBrand = createAsyncThunk(
  "createPQCBrand",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.createPQCBrand,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updatePQCBrand = createAsyncThunk(
  "updatePQCBrand",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.updatePQCBrand,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const deletePQCBrand = createAsyncThunk(
  "deletePQCBrand",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.deletePQCBrand,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const reorderPQCBrands = createAsyncThunk(
  "reorderPQCBrands",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.reorderPQCBrands,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const createPQCSet = createAsyncThunk(
  "createPQCSet",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.createPQCSet,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updatePQCSet = createAsyncThunk(
  "updatePQCSet",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.updatePQCSet,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const deletePQCSet = createAsyncThunk(
  "deletePQCSet",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.deletePQCSet,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const reorderPQCSets = createAsyncThunk(
  "reorderPQCSets",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        prequotedApis.reorderPQCSets,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

const PreQuoteSlice = createSlice({
  name: "Quote",
  initialState: {
    prequote: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPreQuotedCooks.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPreQuotedCooks.fulfilled, (state, action) => {
        state.loading = false;
        state.quote = action.payload;
      })
      .addCase(createPreQuotedCooks.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default PreQuoteSlice.reducer;
